import { IOptionsProps } from '@types';
import { MAX_OPTIONS_SHOWN } from './options-tools';
import { PriceCheckOptions } from './PriceCheckOptions';
import PriceRangeOptions from './PriceRangeOptions';

const PriceFilterOptions = ({ filterOptionsData, ...rest }: IOptionsProps) => {
  if (!filterOptionsData || !Array.isArray(filterOptionsData.price) || !filterOptionsData.price.length) {
    return null;
  }

  if (filterOptionsData.price.length > MAX_OPTIONS_SHOWN) {
    return <PriceRangeOptions filterOptionsData={filterOptionsData} {...rest} />;
  } else {
    return <PriceCheckOptions filterOptionsData={filterOptionsData} {...rest} />;
  }
};

export { PriceFilterOptions };
